module.exports = __webpack_public_path__ + "img/login_03.7f61f7e3.png";